interface RedirectLink {
  field?: string
  urls?: { value: string; redirectTo: string }[]
  default?: boolean
  url?: string
}

export default (redirectLinks: RedirectLink[], params: any, redirectURL: string) => {
  const defaultUrl = redirectLinks.find((l) => l.default && l.url)?.url
  const redirectLinksWithoutDefault = redirectLinks.filter((l) => !l.default)

  return (
    redirectLinksWithoutDefault.reduce((prev: string | null | undefined, curr: RedirectLink) => {
      if (prev) return prev
      if (curr.urls && curr.field) {
        return curr.urls.find((u: any) => u.value === params[curr.field!])?.redirectTo
      }
      return null
    }, null) ||
    defaultUrl ||
    redirectURL
  )
}
